import logo from './logo.svg'

export const Brand = () => {
    return (
        <img style={{ width: '70px' }} src={logo} alt="Logo" className="img-fluid" />
    );
}